import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

interface ParagraphMediaFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphMediaFiltered: React.FC<ParagraphMediaFilteredProps> = () => (
  <div className="Paragraph ParagraphMediaFiltered">
    <Container>
      <View
        id="media_filtered"
        display="media_filtered"
        storageType="url"
        withProvider
      />
    </Container>
  </div>
);

export default ParagraphMediaFiltered;
